import { render } from "./letter-detail.vue?vue&type=template&id=4711d968"
import script from "./letter-detail.vue?vue&type=script&lang=js"
export * from "./letter-detail.vue?vue&type=script&lang=js"

import "./letter-detail.vue?vue&type=style&index=0&id=4711d968&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__